import { render } from "./ViewAuction.vue?vue&type=template&id=182da4e4"
import script from "./ViewAuction.vue?vue&type=script&lang=js"
export * from "./ViewAuction.vue?vue&type=script&lang=js"
script.render = render

export default script